import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./Reducers/Authentication";
export const store = configureStore({
  reducer: {
    authentication: AuthReducer,
  },
});
